import React, { Component } from "react";
import { injectIntl } from "react-intl";
import AcknowledgementLayout from "../../../../Containers/common/acknowledgement";
import CloseIcon from "../../../../Assets/images/close.svg";
// import messages from "./messages";
// import "./style.less";

class ProductMappingsFailure extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
    
    formatMessage = data => this.props.intl.formatMessage(data);

    showUI = () => {

	const {close,data} = this.props;
	
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40  clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal" />
	    </div>
		{/* <div className="flex columns  align-items-center  medium fontsize22 mr20 ml20">
		Failed to deactivate !!!!!!
	    </div> */}
		<div className="flex columns align-items-center  medium fontsize22 mr20 ml20">
		{this.formatMessage(data.message)}
	    </div>

		<div className="flex columns align-items-center  medium fontsize22 mr20 ml20">
		<ul>
			{data&&data.payload&&data.payload.map(error=><li key={error}>{error}</li>)}
		</ul>
		</div>

		<div className="flex justify-content-center align-items-center mt30">
		</div>
		</div>
	);
    }
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}

    return (
	    <AcknowledgementLayout>
	    {this.showUI()}
	    </AcknowledgementLayout>
    );
  }
}

export default injectIntl(ProductMappingsFailure);
